var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeepasswordicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.2C12.5835 14.2 13.1431 13.9683 13.5557 13.5557C13.9683 13.1431 14.2 12.5835 14.2 12C14.2 11.4166 13.9683 10.857 13.5557 10.4444C13.1431 10.0318 12.5835 9.80005 12 9.80005C11.4166 9.80005 10.857 10.0318 10.4444 10.4444C10.0318 10.857 9.80005 11.4166 9.80005 12C9.80005 12.5835 10.0318 13.1431 10.4444 13.5557C10.857 13.9683 11.4166 14.2 12 14.2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50391 12C2.90531 7.53735 7.07431 4.30005 12.0001 4.30005C16.9259 4.30005 21.0949 7.53735 22.4963 12C21.0949 16.4627 16.9259 19.7 12.0001 19.7C7.07431 19.7 2.90531 16.4627 1.50391 12ZM16.4001 12C16.4001 13.167 15.9365 14.2862 15.1114 15.1113C14.2862 15.9365 13.1671 16.4 12.0001 16.4C10.8332 16.4 9.714 15.9365 8.88884 15.1113C8.06368 14.2862 7.60011 13.167 7.60011 12C7.60011 10.8331 8.06368 9.71394 8.88884 8.88878C9.714 8.06362 10.8332 7.60005 12.0001 7.60005C13.1671 7.60005 14.2862 8.06362 15.1114 8.88878C15.9365 9.71394 16.4001 10.8331 16.4001 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeepasswordicon);
export default __webpack_public_path__ + "static/media/seepassword.icon.7851a1f72dd9d915187c23c061c82d70.svg";
export { ForwardRef as ReactComponent };